import $, {
  ajax
} from 'jquery';
import prestashop from 'prestashop';

prestashop.cart = prestashop.cart || {};

prestashop.cart.active_inputs = null;

let spinnerSelector = 'input[name="product-quantity-spin"]';
let hasError = false;
let isUpdateOperation = false;
let errorMsg = '';

/**
 * Attach Bootstrap TouchSpin event handlers
 */
function createSpin() {
  $.each($(spinnerSelector), function (index, spinner) {
    $(spinner).TouchSpin({
      buttondown_class: 'btn js-touchspin',
      buttonup_class: 'btn js-touchspin',
      min: parseInt($(spinner).attr('min'), 10),
      max: 1000000
    });
  });

  CheckUpdateQuantityOperations.switchErrorStat();
}

function checkBeforeCheckout() {
  $(document).on('click', '#btn-checkout', function (e) {
    e.preventDefault();
    // on va passer tous nos tests avant de passer à la saisie des infos de commande
    $.ajax({
      type: "POST",
      url: "module/seq_magasins/ajax",
      data: {
        ajax: true,
        action: 'checkBeforeCheckout',
      },
      success: function (response) {
        const responseObj = JSON.parse(response);
        if (responseObj.success) {
          window.location.href = e.target.href;
        } else {
          // erreur
          const errorMsgStr = () => {
            let message = "<ul>";
            for (let index = 0; index < responseObj.messages.length; index++) {
              message += "<li>" + responseObj.messages[index] + "</li>";
            }
            message += "</ul>";
            return message;
          };
          $('#checkBeforeCheckoutErrors').html(errorMsgStr);
          $('#checkBeforeCheckoutErrors').removeClass('d-none');
        }
      }
    });
  });
}

$(document).ready(() => {
  checkBeforeCheckout();
  const productLineInCartSelector = '.js-cart-line-product-quantity';
  const promises = [];
  const parseQuantity = (value, fallback = 1) => {
    const quantity = parseInt(value, 10);

    return isNaN(quantity) ? fallback : quantity;
  };

  prestashop.on('updateCart', () => {
    $('.quickview').modal('hide');
    $('.js-cart__card-body').addClass('is--loading');
  });

  prestashop.on('updatedCart', () => {
    createSpin();
    $('.js-cart__card-body.is--loading').removeClass('is--loading');
  });

  prestashop.on('handleError', function (event) {
    $('.js-cart__card-body.is--loading').removeClass('is--loading');
  });

  createSpin();

  const $body = $('body');

  function isTouchSpin(namespace) {
    return namespace === 'on.startupspin' || namespace === 'on.startdownspin';
  }

  function shouldIncreaseProductQuantity(namespace) {
    return namespace === 'on.startupspin';
  }

  function findCartLineProductQuantityInput($target) {
    var $input = $target.parents('.bootstrap-touchspin').find(productLineInCartSelector);

    if ($input.is(':focus')) {
      return null;
    }
    return $input;

  }

  function camelize(subject) {
    let actionTypeParts = subject.split('-');
    let i;
    let part;
    let camelizedSubject = '';

    for (i = 0; i < actionTypeParts.length; i++) {
      part = actionTypeParts[i];

      if (0 !== i) {
        part = part.substring(0, 1).toUpperCase() + part.substring(1);
      }

      camelizedSubject = camelizedSubject + part;
    }

    return camelizedSubject;
  }

  function parseCartAction($target, namespace) {
    if (!isTouchSpin(namespace)) {
      return {
        url: $target.attr('href'),
        type: camelize($target.data('link-action'))
      }
    }

    let $input = findCartLineProductQuantityInput($target);
    if (!$input) {
      return;
    }

    let cartAction = {};
    if (shouldIncreaseProductQuantity(namespace)) {
      cartAction = {
        url: $input.data('up-url'),
        type: 'increaseProductQuantity'
      };
    } else {
      cartAction = {
        url: $input.data('down-url'),
        type: 'decreaseProductQuantity'
      }
    }

    return cartAction;
  }

  function getCartActionLinkType(cartActionType) {
    if (cartActionType === 'increaseProductQuantity') {
      return 'add-to-cart';
    }

    if (cartActionType === 'decreaseProductQuantity') {
      return 'remove-from-cart';
    }

    return cartActionType;
  }

  function buildUpdateCartReason(dataset, extraData = {}) {
    return Object.assign({
      idProduct: dataset.idProduct || dataset.productId,
      idProductAttribute: dataset.idProductAttribute || 0,
      idCustomization: dataset.idCustomization || 0,
      linkAction: dataset.linkAction
    }, extraData);
  }

  let abortPreviousRequests = () => {
    var promise;
    while (promises.length > 0) {
      promise = promises.pop();
      promise.abort();
    }
  };

  var getTouchSpinInput = ($button) => {
    return $($button.parents('.bootstrap-touchspin').find('input'));
  };

  var handleCartAction = (event) => {
    event.preventDefault();

    let $target = $(event.currentTarget);
    let cartAction = parseCartAction($target, event.namespace);
    let requestData = {
      ajax: '1',
      action: 'update'
    };

    if (typeof cartAction === 'undefined') {
      return;
    }

    const $eventSource = isTouchSpin(event.namespace) ? getTouchSpinInput($target) : $target;
    const sourceElement = $eventSource.get(0);
    const sourceDataset = sourceElement ? sourceElement.dataset : {};
    const quantity = cartAction.type === 'delete-from-cart'
      ? parseQuantity($eventSource.val(), 1)
      : 1;

    abortPreviousRequests();
    $.ajax({
      url: cartAction.url,
      method: 'POST',
      data: requestData,
      dataType: 'json',
      beforeSend: function (jqXHR) {
        promises.push(jqXHR);
      }
    }).then(function (resp) {
      CheckUpdateQuantityOperations.checkUpdateOpertation(resp);
      var $quantityInput = getTouchSpinInput($target);
      $quantityInput.val(resp.quantity);

      // Refresh cart preview
      prestashop.emit('updateCart', {
        reason: buildUpdateCartReason(sourceDataset, {
          linkAction: getCartActionLinkType(cartAction.type),
          quantity: quantity
        }),
        resp: resp
      });
    }).fail((resp) => {
      prestashop.emit('handleError', {
        eventType: 'updateProductInCart',
        resp: resp,
        cartAction: cartAction.type
      });
    });
  };

  $body.on(
    'click',
    '[data-link-action="delete-from-cart"], [data-link-action="remove-voucher"]',
    handleCartAction
  );

  $body.on('touchspin.on.startdownspin', spinnerSelector, handleCartAction);
  $body.on('touchspin.on.startupspin', spinnerSelector, handleCartAction);

  function sendUpdateQuantityInCartRequest(updateQuantityInCartUrl, requestData, $target, reason) {
    abortPreviousRequests();

    return $.ajax({
      url: updateQuantityInCartUrl,
      method: 'POST',
      data: requestData,
      dataType: 'json',
      beforeSend: function (jqXHR) {
        promises.push(jqXHR);
      }
    }).then(function (resp) {
      CheckUpdateQuantityOperations.checkUpdateOpertation(resp);
      $target.val(resp.quantity);

      // Refresh cart preview
      prestashop.emit('updateCart', {
        reason: reason,
        resp: resp
      });
    }).fail((resp) => {
      prestashop.emit('handleError', {
        eventType: 'updateProductQuantityInCart',
        resp: resp
      })
    });
  }

  function getRequestData(quantity) {
    return {
      ajax: '1',
      qty: Math.abs(quantity),
      action: 'update',
      op: getQuantityChangeType(quantity)
    }
  }

  function getQuantityChangeType($quantity) {
    return ($quantity > 0) ? 'up' : 'down';
  }

  function updateProductQuantityInCart(event) {
    const $target = $(event.currentTarget);
    const updateQuantityInCartUrl = $target.data('update-url');
    const baseValue = parseQuantity($target.attr('value'), 0);

    // There should be a valid product quantity in cart
    const targetValue = parseQuantity($target.val(), -1);
    if (targetValue != parseInt(targetValue) || targetValue < 0 || isNaN(targetValue)) {
      $target.val(baseValue);

      return;
    }

    // There should be a new product quantity in cart
    const qty = targetValue - baseValue;
    if (qty === 0) {
      return;
    }

    $target.attr('value', targetValue);
    sendUpdateQuantityInCartRequest(updateQuantityInCartUrl, getRequestData(qty), $target, buildUpdateCartReason($target.get(0).dataset, {
      linkAction: qty > 0 ? 'add-to-cart' : 'remove-from-cart',
      quantity: Math.abs(qty)
    }));

  }

  $body.on(
    'focusout keyup',
    productLineInCartSelector,
    (event) => {
      if (event.type === 'keyup') {
        if (event.keyCode === 13) {
          updateProductQuantityInCart(event);
        }
        return false;
      }

      updateProductQuantityInCart(event);
    }
  );


  $body.on(
    'click',
    '.js-discount .code',
    (event) => {
      event.stopPropagation();

      const $code = $(event.currentTarget);
      const $discountInput = $('[name=discount_name]');

      $discountInput.val($code.text());

      return false;
    }
  )
});

const CheckUpdateQuantityOperations = {
  'switchErrorStat': () => {
    /**
     * resp.hasError can be not defined but resp.errors not empty: quantity is updated but order cannot be placed
     * when resp.hasError=true, quantity is not updated
     */
    const $checkoutBtn = $('.checkout a');
    if ($("#notifications article.alert-danger").length || ('' !== errorMsg && !hasError)) {
      $checkoutBtn.addClass('disabled');
    }

    if ('' !== errorMsg) {
      let strError = ' <article class="alert alert-danger" role="alert" data-alert="danger"><ul><li>' + errorMsg + '</li></ul></article>';
      $('#notifications .container').html(strError);
      errorMsg = '';
      isUpdateOperation = false;
      if (hasError) {
        // if hasError is true, quantity was not updated : allow checkout
        $checkoutBtn.removeClass('disabled');
      }
    } else if (!hasError && isUpdateOperation) {
      hasError = false;
      isUpdateOperation = false;
      $('#notifications .container').html('');
      $checkoutBtn.removeClass('disabled');
    }
  },
  'checkUpdateOpertation': (resp) => {
    /**
     * resp.hasError can be not defined but resp.errors not empty: quantity is updated but order cannot be placed
     * when resp.hasError=true, quantity is not updated
     */
    hasError = resp.hasOwnProperty('hasError');
    let errors = resp.errors || "";
    // 1.7.2.x returns errors as string, 1.7.3.x returns array
    if (errors instanceof Array) {
      errorMsg = errors.join(" ");
    } else {
      errorMsg = errors;
    }

    isUpdateOperation = true;
  }
};



// WEBPACK FOOTER //
// ./js/cart.js